        <template>
  <div>
    <div v-if="!cookiesObject.token">
      <p class="">
        <button
          type="button"
          class="loginButton btn btn-primary"
          @click="openModal"
        >
          {{ $t("LanguageEn.loginButton") }}
        </button>
      </p>
      <div
        class="modal fade"
        id="exampleModal"
        ref="exampleModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog">
          <div v-if="modalContent == 1" class="modal-content">
            <div
              class="modal-header"
              style="
                background: #212225;
                border-radius: 0px;
                border: none;
                color: white;
                height: 50px;
              "
            >
              <p style="margin-left: 17px; font-weight: 600">Zunisport</p>
            </div>
            <div
              class="modal-body"
              style="background: #1a1a1d; border-radius: 0px"
            >
              <VuePhoneNumberInput
                dark
                v-model="number"
                @update="onUpdate"
                maxlength="13"
                style=""
                class="webLog col"
                :default-country-code="cookiesObject.countryCode"
              />
              <br />
              <button
                type="button"
                class="loginButton1 btn btn-primary"
                style="
                  margin-top: 3.1px;
                  font-size: 12px;
                  width: 438px;
                  margin-left: 15px;
                "
                data-dismiss="modal"
                v-on:click="numberCookie(), regSign()"
              >
                {{ $t("LanguageEn.txtNext") }}
              </button>
            </div>
          </div>
          <div v-else class="modal-content">
            <div
              class="modal-header"
              style="
                background: #212225;
                border-radius: 0px;
                border: none;
                color: white;
                height: 50px;
              "
            >
              <p style="margin-left: 17px; font-weight: 600">Zunisport</p>
            </div>
            <div
              class="modal-body"
              style="background: #1a1a1d; border-radius: 0px; color: white"
            >
              <p>
                Dear user, we can not validate your session security. Please
                make sure your connection is secure and you are using latest
                version of any modern browser.
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="modal fade " id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered ">
    <div class="modal-content ">
      <div class="modal-body" style="margin-bottom: -25px;"> 
        <img src="@/assets/soccer-cover.jpg" style="width: 498px; height: 100%; margin-top: -16px; margin-left: -16px;">
      </div>
      <div class="modal-footer">
        <input type="phone" class="form-control col" id="exampleFormControlInput1" placeholder="Received Code" v-model="OTP" style="margin-left: 10px;">
        <button type="button" class="loginButton btn btn-primary col-2" style="margin-top: 3.1px; font-size: 12px;" data-toggle="modal" data-target="#exampleModal1" v-on:click="verify(), reLoad(), tokenToCookie()">{{ $t('LanguageEn.txtSubmit') }}</button>
      </div>
    </div>
  </div>
</div> -->
    </div>
    <div v-else>
      <p
        class=""
        style="margin-bottom: 0px; margin-top: 0px; margin-left: 0px"
        v-on:click="logout()"
      >
        <img style="width: 24px" src="@/assets/logouts.svg" />
        {{ $t("LanguageEn.logout") }}
      </p>
    </div>
    <b-modal
      header-class="webOtp"
      body-class="webOtp1"
      ref="login-modal"
      style=""
      hide-footer
      hide-header
    >
      <div v-if="modalContent == 1">
        <div
          class="modal-header"
          style="
            background: #212225;
            border-radius: 0px;
            border: none;
            color: white;
            height: 50px;
            margin-bottom: 20px;
          "
        >
          <p style="margin-left: 17px; font-weight: 600">Zunisport</p>
        </div>
        <div class="" style="background: #1a1a1d; border-radius: 0px">
          <VuePhoneNumberInput
            dark
            v-model="number"
            @update="onUpdate"
            maxlength="13"
            style=""
            class="webLog col"
            :default-country-code="cookiesObject.countryCode"
          />
          <br />
          <button
            type="button"
            class="loginButton1 btn btn-primary"
            style="
              margin-top: 3.1px;
              font-size: 12px;
              width: 438px;
              margin-left: 15px;
            "
            data-dismiss="modal"
            v-on:click="numberCookie(), regSign()"
          >
            {{ $t("LanguageEn.txtNext") }}
          </button>
        </div>
      </div>
      <div v-else class="modal-content">
        <div
          class="modal-header"
          style="
            background: #212225;
            border-radius: 0px;
            border: none;
            color: white;
            height: 50px;
          "
        >
          <p style="margin-left: 17px; font-weight: 600">Zunisport</p>
        </div>
        <div
          class="modal-body"
          style="background: #1a1a1d; border-radius: 0px; color: white"
        >
          <p>
            Dear user, we can not validate your session security. Please make
            sure your connection is secure and you are using latest version of
            any modern browser.
          </p>
        </div>
      </div>
    </b-modal>
    <b-modal
      header-class="webOtp"
      body-class="webOtp1"
      ref="otp-modal"
      style=""
      hide-footer
      title="OTP"
    >
      <b-row style="">
        <b-col cols="9">
          <input
            type="phone"
            class="form-control"
            maxlength="5"
            id="exampleFormControlInput1"
            :placeholder="$t('LanguageEn.pinText')"
            v-model="OTP"
            style="
              margin-left: 10px;
              background: #212225;
              border-radius: 1px;
              border-color: #2c2d31;
              color: white;
            "
            v-on:keyup.enter="verify()"
          />
        </b-col>
        <b-col>
          <button
            type="button"
            class="loginButton btn btn-primary"
            style="margin-top: 0px; font-size: 12px"
            data-toggle="modal"
            data-target="#exampleModal1"
            v-on:click="verify()"
          >
            {{ $t("LanguageEn.txtSubmit") }}
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="regText-modal"
      title="Register"
      header-class="webOtp"
      body-class="webOtp1"
      style=""
      hide-footer
    >
      <div></div>
      <p v-if="introText.code == 200" style="margin-top: 10px; color: #e6e6e6">
        {{ introText.page.text }}
      </p>
      <b-row>
        <b-col>
          <button
            type="submit"
            class="btn mbtn btn-default btn-block"
            style="z-index: 0; background: none; color: #ff324d"
            @click="$refs['regText-modal'].hide()"
          >
            {{ $t("LanguageEn.can") }}
          </button>
        </b-col>
        <b-col>
          <button
            type="submit"
            class="btn btn-default btn-block"
            style="z-index: 0; background: none; color: #228c39"
            @click="$refs['regText-modal'].hide(), $refs['otp-modal'].show()"
          >
            {{ $t("LanguageEn.txtConfirm") }}
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="regText1-modal"
      title="Register"
      header-class="webOtp"
      body-class="webOtp1"
      style=""
      hide-footer
    >
      <div></div>
      <p
        v-if="introText.code == 200"
        style="margin-top: 10px; color: #e6e6e6"
        v-html="introText.page.text"
      ></p>
      <b-row>
        <b-col>
          <button
            type="submit"
            class="btn btn-default btn-block"
            style="z-index: 0; background: none; color: #228c39"
            @click="$refs['regText1-modal'].hide()"
          >
            {{ $t("LanguageEn.ok") }}
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="error-modal"
      header-class="webOtp"
      body-class="webOtp1"
      size="md"
      hide-footer
      title="Oops!"
    >
      <p style="text-align: center; color: #e6e6e6">{{ errorText }}</p>
      <b-row>
        <b-col style="text-align: left"> </b-col>
        <b-col style="text-align: right">
          <b-button
            type="submit"
            class="loginButton"
            @click="$refs['error-modal'].hide()"
            variant=""
            >CLOSE</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import { mapGetters } from "vuex";

export default {
  name: "LoginP",
  data() {
    return {
      data: "",
      OTP: "",
      number: "",
      portalLenght: "",
      regOrNot: "",
      token: "",
      clientToken: "Web_" + Date.now() + "_" + this.number,
      username: "",
      cookiesObject: "",
      UserName: "",
      results: {},
      modalContent: 1,
      introText: "",
      errorText: "",
    };
  },
  async created() {
    var res = await fetch(this.httpReq + "/general/appData");
    var data = await res.json();
    this.data = data;

    var portalLenght = data.portals.length;
    this.portalLenght = portalLenght;

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    var resp = await fetch(
      this.httpReq +
        "/general/page?languageId=" +
        (this.cookiesObject.langId ? this.cookiesObject.langId : 0) +
        "&link=registration_intro&portalId=" +
        (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0)
    );
    var dataa = await resp.json();
    this.introText = dataa;
  },

  methods: {
    // opMod(){
    //   this.$("#exampleModal1").modal({show: true});
    // },
    openModal() {
      this.checkEvina();

      if (this.cookiesObject.evina) {
        var requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        fetch(
          `http://sportapi.zuniac.com/evina/check?transaction=${this.cookiesObject.evina}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result.code == 200) {
              this.modalContent = 1;
            } else {
              this.modalContent = null;
            }
          })
          .catch((error) => console.log("error", error));
      }
    },

    checkEvina() {
      //'portal' for evina not 'portalS'

      if (
        this.data.portals[0]?.params.he_enabled == "yes" &&
        this.data.portals[0]?.params.evina_enabled == "1"
      ) {
        this.evinaFlow();
      } else {
        this.$refs["login-modal"].show();
      }
    },

    evinaFlow() {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/evina/check?transaction=${localStorage.getItem(
          "transactionId"
        )}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result.code);
          if (result.code == 200) {
            this.heStart();
          } else {
            alert("Error while Evina check");
          }
        })
        .catch((error) => console.log("error", error));
    },

    heStart() {
      console.log(this.cookiesObject.portalId);
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/he/start?portalId=${this.cookiesObject.portalId}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          var requestOptions = {
            method: "GET",
            redirect: "follow",
          };

          fetch(result.url, requestOptions)
            .then((response) => response.json())
            .then((result) => {
              this.heEnd(result.transactionId);
            })
            .catch((error) => console.log("error", error));
        })
        .catch((error) => console.log("error", error));
    },
    heEnd(trId) {
      var requestOptions = {
        method: "GET",
        redirect: "follow",
      };

      fetch(
        `http://sportapi.zuniac.com/he/end?portalId=${
          this.cookiesObject.portalId
        }&trxId=${trId}&clientToken=${Math.random()}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.code == 200) {
            document.cookie =
              "token =" +
              result.token +
              ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

            var appParams = fetch(
              this.httpReq + "/general/appData?token=" + result.token
            );
            var evParams = appParams.json();
            document.cookie =
              "portalId =" +
              evParams.portal.id +
              ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
            document.cookie = "countryCode =" + evParams.portal.countryCode;
            this.reLoad();
          } else {
            this.$refs["login-modal"].show();
          }
        })
        .catch((error) => console.log("error", error));
    },

    logout() {
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "langId = 1; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "lang = en; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      location.assign("/");
    },
    numberCookie() {
      document.cookie =
        "number =" + this.number + ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
    },
    async regSign() {
      var res = await fetch(
        this.httpReq +
          "/user/status?msisdn=" +
          this.results.formattedNumber.slice(1)
      );
      var data = await res.json();
      var regOrNot = data.code;

      this.regOrNot = regOrNot;

      // console.log(data.portals[0].params.registration_enabled)

      // if (regOrNot == 404) {
      //   this.$refs['otp-modal'].show()
      // }

      if (regOrNot == 200) {
        var res1 = await fetch(
          this.httpReq +
            "/user/login/otp?msisdn=" +
            this.results.formattedNumber.slice(1),
          { method: "post" }
        );
        await res1.json();

        this.$refs["otp-modal"].show();
      } else if (regOrNot == 404) {
        if (data.portals.length == 0) {
          this.errorText = "Number is not allowed for service";
          this.$refs["error-modal"].show();
        } else {
          if (data.portals[0].params.registration_enabled == 1) {
            var res2 = await fetch(
              this.httpReq +
                "/user/register/otp?msisdn=" +
                this.results.formattedNumber.slice(1) +
                "&portalId=" +
                data.portals[0].id,
              { method: "post" }
            );
            var dataresp = await res2.json();

            if (dataresp.code == 200) {
              if (this.cookiesObject.regText == 1) {
                this.$refs["regText-modal"].show();
              } else {
                this.$refs["otp-modal"].show();
              }
            } else if (dataresp.code == 405) {
              this.errorText = "Already registered";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // location.assign("/");
            } else if (dataresp.code == 404) {
              this.errorText = "Portal not found";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 500) {
              this.errorText = "Oops, something went wrong!";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 818) {
              this.errorText = "Subscription system error";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else if (dataresp.code == 408) {
              this.errorText = "Registration on this portal is disabled";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            } else {
              this.errorText = "Server error";
              this.$refs["error-modal"].show();
              document.cookie =
                "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              document.cookie = "langId = 1";
              document.cookie = "lang = en";
              document.cookie =
                "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              // document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
              //  location.assign("/");
            }
          } else {
            this.$refs["regText1-modal"].show();
          }
        }
      }
      this.regOrNot = regOrNot;
    },
    async verify() {
      if (this.regOrNot == 404) {
        var res3 = await fetch(
          this.httpReq +
            "/user/register/verify?clientToken=" +
            this.clientToken +
            "&msisdn=" +
            this.results.formattedNumber.slice(1) +
            "&otp=" +
            this.OTP,
          { method: "post" }
        );
        var data3 = await res3.json();
        var token = data3.token;
        this.token = token;

        if (data3.code == 406) {
          this.errorText = "You entered Wtong OTP";
          this.$refs["error-modal"].show();
        } else if (data3.code == 500) {
          this.errorText = "Server error, try logging later";
          this.$refs["error-modal"].show();
        } else if (data3.code == 200) {
          document.cookie =
            "token =" +
            this.token +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          var res13 = await fetch(
            this.httpReq + "/general/appData?token=" + this.token
          );
          var data13 = await res13.json();
          document.cookie =
            "portalId =" +
            data13.portal.id +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
          document.cookie = "countryCode =" + data13.portal.countryCode;

          this.reLoad();
        } else {
          this.errorText = "Server error, try logging later";
          this.$refs["error-modal"].show();
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        }
      } else if (this.regOrNot == 200) {
        var res = await fetch(
          this.httpReq +
            "/user/login/verify?clientToken=" +
            this.clientToken +
            "&msisdn=" +
            this.results.formattedNumber.slice(1) +
            "&otp=" +
            this.OTP,
          { method: "post" }
        );
        var data = await res.json();
        var token1 = data.token;
        this.token = token1;

        if (data.code == 406) {
          this.errorText = "You entered Wrong OTP";
          this.$refs["error-modal"].show();
        } else if (data.code == 500) {
          this.errorText = "Server error, Try logging later";
          this.$refs["error-modal"].show();
        } else if (data.code == 200) {
          document.cookie =
            "token =" +
            this.token +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          var res12 = await fetch(
            this.httpReq + "/general/appData?token=" + this.token
          );
          var data12 = await res12.json();
          document.cookie =
            "portalId =" +
            data12.portal.id +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";
          document.cookie = "countryCode =" + data12.portal.countryCode;
          this.reLoad();
        }
      } else {
        this.errorText = "Server error, try logging later";
        this.$refs["error-modal"].show();
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }
    },
    reLoad() {
      setTimeout(function some() {
        document.cookie =
          "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
      }, 100);
    },
    onUpdate(payload) {
      this.results = payload;
    },
  },
  components: {
    VuePhoneNumberInput,
  },
  computed: {
    ...mapGetters(["favsTe", "favs", "favsT", "httpReq"]),
    resultsTable() {
      return Object.keys(this.results);
    },
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #f0af49;
  text-align: center;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  letter-spacing: 1px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
.goldLogin {
  height: 64px;
  justify-content: center;
  padding-top: 10%;
  font-weight: 400;
}

.loginButton {
  background: #212225;
  border: solid #1c5e20;
  border-width: 2px;
  margin-right: 10px;
  color: white;
  float: right;
  border-radius: 2px;
  height: 39px;
  margin-top: -8px;
}
.loginButton1 {
  background: #212225;
  border: solid #1c5e20;
  border-width: 2px;
  margin-right: 10px;
  color: white;
  border-radius: 2px;
  height: 39px;
  margin-top: -8px;
}
.loginButton:hover {
  background: #1c5e20;
}
.loginButton1:hover {
  background: #1c5e20;
}

.blackBG {
  background: #212529;
}
</style>
<style>
.webLog .country-selector__input {
  background: #222326 !important;
  color: white;
}

.webLog .input-tel__input {
  background: #222326 !important;
  color: white;
}

.webOtp1 {
  background: #1a1a1d !important;
  border-radius: 0px !important;
}
.webOtp {
  background: #212225 !important;
  border: none;
  color: white;
  border-radius: 0px !important;
  height: 50px;
}
</style>